const NAME = "PERFORMANCE_ANALYTICS_HISTORIC";

export default NAME;